import { render } from "./taskIndex.vue?vue&type=template&id=63dd061c"
import script from "./taskIndex.vue?vue&type=script&lang=js"
export * from "./taskIndex.vue?vue&type=script&lang=js"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__